import supportedLanguages from 'app/utils/supportedLanguages';
/**
 * The backend accepts `is_deactivated` instead of `isEnabled`
 *
 * @param translations
 */
export function getDenormalizedTranslations(translations = {}) {
    return Object.entries(translations).reduce((tr, [locale, translation]) => {
        if (!translation.content || !translation.content.trim()) {
            return tr;
        }
        return Object.assign(Object.assign({}, tr), { [locale]: {
                subject: translation.subject || undefined,
                content: translation.content,
                is_deactivated: !translation.isEnabled,
            } });
    }, {});
}
export function normalizeTemplate(template) {
    return Object.assign(Object.assign({}, template), { translations: Object.keys(template.translations || {}).reduce((tr, locale) => (Object.assign(Object.assign({}, tr), { [locale]: Object.assign(Object.assign({}, template.translations[locale]), { isEnabled: !template.translations[locale].is_deactivated }) })), {}) });
}
export const helpText = `You can use these replacing variables eg. *{{agent_fullname}}* with the actual agent name:

  {{organization_name}}
  {{requester_firstname}}
  {{requester_fullname}}
  {{requester_email}}
  {{agent_firstname}}
  {{agent_fullname}}
  {{conversation_subject}}
  {{csid}}

  _note_: csid is the conversation ID.`;
export const defaultLanguageCode = 'en';
export const languages = supportedLanguages.concat().sort((a, b) => {
    if (a.code === defaultLanguageCode)
        return -1;
    if (b.code === defaultLanguageCode)
        return 1;
    return 0;
});
